import { RootState } from 'redux/store'

export const selectFilesControlsVisibility = (state: RootState): boolean => state.files.controls.isVisible
export const selectFilesControlsShowAllVersions = (state: RootState): boolean => state.files.controls.showAllVersions
